import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { WizAgGrid, WizBasePopUp, WizDatasource } from '@wizeoo/akm-component-lib';
import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { ViewData } from '../../../../../model/view.data';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { ScenarioVO } from '../../../../../vo/scenarii/scenario.vo';
import { EM_ACTION, WidgetLine } from '@wizeoo/akm-compute-lib';
import { PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { clone } from 'lodash-es';

@Component({
  // popUp d'édition des cellules de grid
  selector: 'pivot-cell-mass-delete-pop',
  templateUrl: './pivot-cell-mass-delete.pop.html',
})
export class PivotCellMassDeletePop extends WizBasePopUp implements AfterViewInit {
  @ViewChild('agGrid') agGrid: WizAgGrid<WidgetLine>;

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.doDelete();
    }
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  public static width: string = '600px';
  public static height: string = '350px';
  
  /** la DS du grid */
  public mainDS: WizDatasource<WidgetLine> = new WizDatasource<WidgetLine>().build();

  public widget: IWidget; // accesseur sur le pivot


  private get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  private get fei(): FeiVO {
    return this.popupData.widget.fei as FeiVO;
  }

  private get lines(): WidgetLine[] {
    return this.popupData.pack;
  }

  public scenario: ScenarioVO = null;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void { 
    
    this.widget = clone(this.popupData.widget); // clone, on touche pas au widget source

    if(this.popupData.line.scen !== ViewData.DEFAULT_SCENARIO) {
      this.scenario = this.widget.model.scenarioEngine.getScenario(this.popupData.widget.vision.code, this.popupData.line.scen);
    }
    this.feedDatasources();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.agGrid.api.setColumnDefs([]); // on rince les colonnes
    this.agGrid.api.setColumnDefs(this.widget.model.feiEngine.buildColumnsForMassEdit(this.fei, this.widget)); // générer les colonnes depuis le contexte
    this.mainDS.setSource(this.lines); // alimentation de la DS des lignes // avec un max

  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  /** confirmation de la suppression */
  public doDelete(): void {

    const updateRequest: UpdateRequest = {
      fei: this.fei,
      line: this.popupData.line,  
      lines: this.popupData.pack, 
      operation: EM_ACTION.DELETE,
      fkd: this.popupData.fkd,
      value: null,
      doSplit: false,
    };
          
    this.popupData.updates = updateRequest;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates 
    this.hide();
  }

  /** libellé du scénario en cours */
  public get scenColor(): string {
    return this.scenario?.color;
  }

  /** libellé du scénario en cours */
  public get scenLabel(): string {
    return this.scenario?.trsLabel;
  }

  /**
   * affichage du libellé du scenario (sauf si main)
   */
  public get showScenLabel(): boolean {
    return !!this.scenario;
  }

}
